/**
 * @generated SignedSource<<6593dfa26d02bf89383e44220c09f7da>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RowInner_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"IssueRow" | "useRowColor_rules">;
  readonly " $fragmentType": "RowInner_project";
};
export type RowInner_project$key = {
  readonly " $data"?: RowInner_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"RowInner_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "RowInner_project",
  "selections": [
    {
      "condition": "isConditionalFormattingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "useRowColor_rules"
        }
      ]
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "IssueRow"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "1a055360fc207bcfdb801873f09db610";

export default node;
